export const SWITCH_TYPES = {
  BASIC: 'Basic',
  ALERT: 'Alert',
  SUCCESS: 'Success',
}

export const LABEL_PLACEMENT = {
  LEFT: 'start',
  RIGHT: 'end',
  TOP: 'top',
  BOTTOM: 'bottom',
}
